import React, { useState } from 'react';
import { Icon, Row, Col, DatePicker, Tooltip } from "antd";
import { getTotalPice } from "../services/display";
import NumberFormat from "./NumberFormat";
import moment from 'moment';
import CardGeneralHolder from "./Styles/cardGeneralStyle";
import { useTranslation } from 'react-i18next';
import 'moment/locale/es';
import 'moment/locale/en-gb';
import ModalChangeDates from './ModalChangeDates';


const CardGeneralComponent = (props) => {
  const { t, i18n } = useTranslation();
  const { editCampaignActive, currentCampaign, date_from, date_to, setDates, programmatic, stepsCurrent } = props;
  const [endOpen, setEndOpen] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const disabledDateEnd = (endValue) => {
    if (!endValue || !date_from) {
      return false;
    }
    return endValue.isBefore(date_from);
  };


  const disabledDateStart = (startValue) => {
    if (!startValue) return false;
    // Allow any date from today onwards, without forcing the relationship with date_to
    return startValue.isBefore(moment().startOf('day'));
  };

  const handleStartOpenChange = (open) => {
    if (!open) {
      setEndOpen(true);
    }
  };

  const handleEndOpenChange = (open) => {
    setEndOpen(open);
  };

  const disabledDate = editCampaignActive
    ? currentCampaign.payment_status === "approved"
    : false;

  return (
    <CardGeneralHolder hasRedistribute={programmatic === "programmatic" && stepsCurrent !== 0 }>
      <div className="cardGeneral">
        <Row justify="center">
          <Col>
            <div className="calendar-container">
              <div className='contentDate'>
                <div className='infoDate'>{t("Start date")}</div>
                <DatePicker
                  allowClear={false}
                  value={moment(date_from)}
                  format={i18n.language === 'en' ? "MM-DD-YYYY" : "DD-MM-YYYY"}
                  suffixIcon={<Icon type="down" />}
                  onChange={(date) => {
                    setDates(
                      date.format("YYYY-MM-DD"),
                      moment(date_to).isBefore(date) ? date.format("YYYY-MM-DD") : date_to
                    );
                  }}
                  onOpenChange={handleStartOpenChange}
                  disabledDate={disabledDateStart}
                  disabled={disabledDate}
                  className='datePicker'
                />
              </div>
              <div className='contentDate'>
                <div className='infoDate'>{t("Finish date")}</div>
                <DatePicker
                  allowClear={false}
                  value={moment(date_to)}
                  format={i18n.language === 'en' ? "MM-DD-YYYY" : "DD-MM-YYYY"}
                  suffixIcon={<Icon type="down" />}
                  onChange={(date) => {
                    setDates(
                      moment(date_from).isAfter(date) ? date.format("YYYY-MM-DD") : date_from,
                      date.format("YYYY-MM-DD")
                    );
                    setIsModalVisible(true);
                  }}
                  open={endOpen}
                  onOpenChange={handleEndOpenChange}
                  disabledDate={disabledDateEnd}
                  disabled={disabledDate}
                  className='datePicker'
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <ModalChangeDates
        visible={isModalVisible}
        onCancel={handleModalClose}
        content={null}
      />
    </CardGeneralHolder>
  );
};

export default CardGeneralComponent;